"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _HTMLVideoContent = _interopRequireDefault(require("./HTMLVideoContent"));

var _VimeoContent = _interopRequireDefault(require("./VimeoContent"));

var _YouTubeContent = _interopRequireDefault(require("./YouTubeContent"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var YOUTUBE_DOMAIN = "youtube.com";
var YOUTUBE_WWW_DOMAIN = "www.youtube.com";
var YOUTUBE_SHORT_DOMAIN = "youtu.be";
var YOUTUBE_WWW_SHORT_DOMAIN = "www.youtu.be";
var VIMEO_DOMAIN = "vimeo.com";
var VIMEO_WWW_DOMAIN = "www.vimeo.com"; // This is a workaround
// - Today, there is no good URL polyfill for older browser
// - Instead of writing a URL parser, for older browser, we will use this <a href> trick to parse the URL

function parseURL(url) {
  var urlLike;

  if (typeof URL === 'function') {
    urlLike = new URL(url);
  } else {
    urlLike = document.createElement('a');
    urlLike.setAttribute('href', url);
  }

  var _urlLike = urlLike,
      hostname = _urlLike.hostname,
      pathname = _urlLike.pathname,
      search = _urlLike.search;
  return {
    hostname: hostname,
    pathname: pathname,
    search: search
  };
}

var _default = function _default(_ref) {
  var alt = _ref.alt,
      autoPlay = _ref.autoPlay,
      loop = _ref.loop,
      poster = _ref.poster,
      src = _ref.src;

  var _parseURL = parseURL(src),
      hostname = _parseURL.hostname,
      pathname = _parseURL.pathname,
      search = _parseURL.search;

  var lastSegment = pathname.split('/').pop();
  var searchParams = new URLSearchParams(search);

  switch (hostname) {
    case VIMEO_DOMAIN:
    case VIMEO_WWW_DOMAIN:
      return _react.default.createElement(_VimeoContent.default, {
        alt: alt,
        autoPlay: autoPlay,
        embedID: lastSegment,
        loop: loop
      });

    case YOUTUBE_DOMAIN:
    case YOUTUBE_WWW_DOMAIN:
      return _react.default.createElement(_YouTubeContent.default, {
        alt: alt,
        autoPlay: autoPlay,
        embedID: searchParams.get('v'),
        loop: loop
      });

    case YOUTUBE_SHORT_DOMAIN:
    case YOUTUBE_WWW_SHORT_DOMAIN:
      return _react.default.createElement(_YouTubeContent.default, {
        alt: alt,
        autoPlay: autoPlay,
        embedID: lastSegment,
        loop: loop
      });

    default:
      return _react.default.createElement(_HTMLVideoContent.default, {
        alt: alt,
        autoPlay: autoPlay,
        loop: loop,
        poster: poster,
        src: src
      });
  }
};

exports.default = _default;